import type { ReactNode } from 'react';
import type { AccessorFnColumnDef, ColumnDef } from '@tanstack/react-table';
import type { TypographyProps } from '../../typography';

interface CustomTableColumnDef<TData extends object, TValue = any> {
  id: string;
  renderWhenEmpty?: ReactNode;
  align?: 'left' | 'right' | 'center';
  pin?: boolean;
  isActionColumn?: boolean;
  columns?: TableColumnDef<TData, TValue>[];
  typography?: TypographyProps | ((row: TData | undefined) => TypographyProps | undefined);
  skeleton?: TableColumnDef<TData, never>['cell'];
}

export type TableColumnDef<TData extends object, TValue = any> = ColumnDef<TData, TValue> & CustomTableColumnDef<TData, TValue>;

export type TableColumnDefWithAccessorFn<TData extends object, TValue = any> = AccessorFnColumnDef<TData, TValue> &
  CustomTableColumnDef<TData, TValue>;

export const DEFAULT_COLUMN_DEF: Partial<TableColumnDef<any>> = {
  enableSorting: false,
};
